import { EMPTY_ARRAY, EMPTY_OBJECT, EMPTY_STRING } from "../../constants/Constants";
export const addAttachment = function () {
  let prevAttachmentList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_ARRAY;
  let newAttachment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_OBJECT;
  const attachments = Object.assign([], prevAttachmentList);
  const {
    response = EMPTY_OBJECT,
    name = EMPTY_STRING,
    type = EMPTY_STRING
  } = newAttachment;
  const {
    id,
    path,
    preview,
    name: responseName
  } = response;
  attachments.push({
    id,
    name: name || responseName,
    type,
    url: path,
    preview
  });
  return attachments;
};
const getAttachmentId = attachment => {
  const {
    response,
    uid
  } = attachment;
  if (!response) {
    return uid;
  }
  const {
    id
  } = response;
  return id;
};
export const removeAttachment = function () {
  let prevAttachmentList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_ARRAY;
  let removeFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_OBJECT;
  const id = getAttachmentId(removeFile);
  return prevAttachmentList.filter(item => item.id !== id);
};